import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { showAnimation } from 'src/animations';
import { NextcloudFile } from 'src/app/classes';
import { OnlyofficeDialogComponent, OnlyofficeDialogComponentData } from 'src/app/lib/nextcloud/components/dialog/onlyoffice-dialog/onlyoffice-dialog.component';
import { FileService } from 'src/app/lib/nextcloud/services/file.service';
import { Issue } from '../../../classes';
import { IIssueProviderService, IIssueTransactionView, ISSUE_PROVIDER_SERVICE } from '../../../interfaces';
import { Step, STEP_FORM_GROUP } from '../../dialog/issue-transaction-dialog2/issue-transaction-dialog2-component-classes';

@Component({
  selector: 'app-folder-structure',
  templateUrl: './folder-structure.component.html',
  styleUrls: ['./folder-structure.component.css'],
  animations: [showAnimation]
})
export class FolderStructureComponent implements IIssueTransactionView, OnDestroy, OnInit {

  downloadSelectionMapReadOnly: { [key: string]: boolean } = {};

  root: NextcloudFile = null;
  rootName: string = null;
  nextcloudFolder: NextcloudFile[] = [];

  _subscriptions: Subscription[] = [];

  constructor(
    @Inject('step') private _step: Step,
    @Inject(ISSUE_PROVIDER_SERVICE) private _issueService: IIssueProviderService,
    @Inject(STEP_FORM_GROUP) public formGroup: FormGroup,
    private _fileService: FileService,
    private _snackBar: MatSnackBar,
    private _dialog: MatDialog,
    private _formBuilder: FormBuilder
  ) { }

  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this._subscriptions.push(...[
      this.downloadControl.valueChanges.subscribe((fileHrefs: string[]) => this._step.visibleInConclusion = fileHrefs.length > 0? true: false),
      this._issueService
        .issue$
        .pipe(filter((x) => x && x.folderlocation ? true : false))
        .pipe(switchMap((x: Issue) => this._fileService.getFolderByPath(x.folderlocation)))
        .subscribe((result: NextcloudFile[]) => {
          let files = [];
          for (let file of result) file.isItself ? this.root = file : files.push(file);
          this.nextcloudFolder = files;
          if (this.root) this.rootName = FileService.getFileName(this.root.href);
          for (let file of this.nextcloudFolder) {
            this.downloadSelectionMapReadOnly[file.uuid] = (this.downloadControl.value as string[]).includes(file.href);
          }
        })
    ]);
  }

  previewFile(event: Event, file: NextcloudFile) {
    event.stopPropagation();
    this._fileService.previewFile(file);
  }

  toggleSelection(file: NextcloudFile) {
    if (this.downloadSelectionMapReadOnly[file.uuid]) {
      this.downloadSelectionMapReadOnly[file.uuid] = false;
      let index = this.downloadControl.controls.findIndex(x => x.value === file.href);
      if (index > -1) this.downloadControl.removeAt(index);
    } else {
      this.downloadSelectionMapReadOnly[file.uuid] = true;
      let index = this.downloadControl.controls.findIndex(x => x.value === file.href);
      if (index === -1) this.downloadControl.push(this._formBuilder.control(file.href))
    }
  }

  get downloadControl(): FormArray {
    return this.formGroup.controls['download'] as FormArray;
  }

}
